import VueRouter, { NavigationGuardNext, Route } from 'vue-router'
import { Middleware, MiddlewareContext } from './types'

type Next = NavigationGuardNext<Vue>

const extractMiddlewares = (route: Route): Middleware[] => {
  let middlewares: Middleware[] = []

  route.matched.forEach((r) => {
    const routeMiddlewares = r?.meta?.middlewares

    if (routeMiddlewares) {
      middlewares = [...middlewares, ...routeMiddlewares]
    }
  })

  return middlewares
}

const makeNext = (cxt: MiddlewareContext, middlewares: Middleware[], i = 0): Next => {
  if (!middlewares[i] || typeof middlewares[i] !== 'function') {
    return cxt.next
  }

  return () => middlewares[i]({ ...cxt, next: makeNext(cxt, middlewares, i + 1) })
}

const beforeEachGuard = (router: VueRouter): void => {
  router.beforeEach((to, from, next) => {
    const middlewares = extractMiddlewares(to)

    if (middlewares.length === 0) {
      return next()
    }

    return makeNext(
      {
        to,
        from,
        next,
        router,
      },
      middlewares
    )()
  })
}

export default beforeEachGuard
